import { defaultUrlTransform } from "react-markdown";

/**
 * react-markdown's own link check, plus `tel:`.
 *
 * The default allows only http(s), irc(s), mailto and xmpp and empties any
 * other href, so `[010-183 98 18](tel:+46101839818)` rendered as a link to
 * nowhere. Real phone numbers have to be explicit `tel:` links, because the
 * site turns off iOS Safari's own phone-number detection (`pages/_app.tsx`).
 */
export const markdownUrlTransform = (url: string): string =>
  /^tel:/i.test(url) ? url : defaultUrlTransform(url);
